import React from "react";
import { useNavigate } from "react-router-dom";
import {  FiMapPin, FiBookmark, FiShare2 } from "react-icons/fi";
// import { FaStar } from "react-icons/fa";
import "../styles/dash_JobCard.css"

function timeAgo(dateStr) {
  if (!dateStr) return "Just now";

  const now = new Date();
  const d = new Date(dateStr + "Z"); //added on 2-1-2026

  if (isNaN(d)) return "Just now";

  const seconds = Math.floor((now - d) / 1000);
  const units = [
    { name: "year", sec: 31536000 },
    { name: "month", sec: 2592000 },
    { name: "week", sec: 604800 },
    { name: "day", sec: 86400 },
    { name: "hour", sec: 3600 },
    { name: "minute", sec: 60 },
  ];

  for (let u of units) {
    const val = Math.floor(seconds / u.sec);
    if (val >= 1) return `${val} ${u.name}${val > 1 ? "s" : ""} ago`;
  }
  return "Just now";
}

export default function dash_JobCard({ job, layout = "grid" }) {
  const navigate = useNavigate();

  const {
    // id,
    title = "IT Job",
    company = "ABC Company",
    companyLogo = "",
    // yoe = "1 year experince",
    location = "Krishnagiri",
    salary,
    // description = "",
    // skills = [],
    postedAt,
    postedBy = "HR",
  } = job || {};

  //added on 19.12.2025

  const saveJob = (job) => {
    const savedJobs = JSON.parse(localStorage.getItem("savedJobs")) || [];
  
    const exists = savedJobs.find(j => j.id === job.id);
    if (!exists) {
      savedJobs.push(job);
      localStorage.setItem("savedJobs", JSON.stringify(savedJobs));
    }
  };


  return (
    <article className={`dash-job-card ${layout === "list" ? "horizontal" : "vertical"}`}>
      
      <div className="dash-job-main">
        
        <div className="dash-title-row">
          <div className="dash-title-left">
            <h3 className="dash-job-title">{title}</h3>
            <div className="dash-company">{company}</div>
          </div>

          {companyLogo ? (
            <img className="dash-logo" src={companyLogo} alt=""
            // alt={`${company} logo`} 
            />
          ) : null}
        </div>

        <div className="dash-meta-row">
          {/* <div className="meta-item">
            <FiBriefcase className="icon" />
            <strong>{yoe}</strong>
          </div> */}

          <div className="dash-meta-item">
            <FiMapPin className="dash-icon" />
            <span>{location}</span>
          </div>

          {salary && (
            <div className="dash-meta-item">
              <span className="dash-salary-icon"></span>
              <span>{salary}</span>
            </div>
          )}
        </div>

        {/* <p className="short-desc">{description}</p>

        <div className="skills-row">
          {(skills || []).map((s, i) => (
            <div className="skill" key={i}>
              <FaStar className="star" /> <span>{s}</span>
            </div>
          ))}
        </div> */}

      </div>

      <div className="dash-job-footer">
        <div className="dash-posted">
          Posted {timeAgo(postedAt)} by{" "}
          <span className="dash-posted-by">{postedBy}</span>
        </div>

        <div className="dash-action-row">
          <button className="dash-icon-btn" aria-label="save" title="Save" onClick={() => saveJob(job)}>
            <FiBookmark />
          </button>

          <button className="dash-icon-btn" aria-label="share" title="Share">
            <FiShare2 />
          </button>
          

          <button
            className="dash-apply-btn"
            /*onClick={() => {
              if (window.confirm("Complete your profile to continue.")) {
                navigate("/candidate-profile");
              }
            }}*/
           // After intergration with backend, replace above onClick with below
           onClick={() => {
              const profile = JSON.parse(localStorage.getItem("ProfileHighlight"));

              const isComplete =
                profile &&
                profile.mobile &&
                profile.qualification &&
                profile.specialization &&
                profile.skills?.length > 0 &&
                profile.experience?.length > 0 &&
                profile.education?.length > 0;

              {/*if (!isComplete) {
                if (window.confirm("Complete your profile to continue.")) {
                  navigate("/candidate-profile");
                }
                return;
              }*/}

              // ✅ Profile completed → allow apply
              //alert("Application submitted successfully!");
              navigate(`/job/${job.id}`);
            }}
            
            aria-label="Apply"
          >
            View
          </button>
        </div>
      </div>

    </article>
  );
}
